export default {"src":"/_next/static/media/TreeThree.1192187c.svg","height":266,"width":127,"blurWidth":0,"blurHeight":0};